/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {
  RendererModule,
  NGRenderMode as ɵNGRenderMode,
  NGRenderModeAPI as ɵNGRenderModeAPI,
} from './src/module';
export { TransferHttpCacheModule } from './src/transfer-http-cache/transfer-http-cache.module';
